<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="orderForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-row(:span='24')
                    el-col(:md='6' :sm='8')
                        el-form-item(label="订单编号" prop="orderNumber")
                            div.width_label {{orderForm.orderNumber}}
                    el-col(:md='6' :sm='8')
                        el-form-item(label="主办方" prop="orgName")
                            div.width_label {{orderForm.orgName}}
                    el-col(:md='6' :sm='8')
                        el-form-item(label="会员姓名" prop="orderUserName")
                            div.width_label {{orderForm.orderUserName}}
                    el-col(:md='6' :sm='8')
                        el-form-item(label="会员账号" prop="account")
                            div.width_label {{orderForm.account}}
                el-row(:span='24')
                    el-col(:md='6' :sm='8')
                        el-form-item(label="培训Id" prop="busId")
                            div.width_label {{orderForm.busId}}
                    el-col(:md='6' :sm='8')
                        el-form-item(label="培训名称" prop="busName")
                            div.width_label {{orderForm.busName}}
                    el-col(:md='6' :sm='8')
                        el-form-item(label="支付金额" prop="payAmount")
                            div.width_label ¥{{orderForm.payAmount}}元
                    el-col(:md='6' :sm='8')
                        el-form-item(label="退款比例" prop="refundScale" v-if='orderForm.refundScale')
                            div.width_label {{orderForm.refundScale}}%
                    el-col(:md='6' :sm='8')
                        el-form-item(label="退款金额" prop="refundAmount" v-if='orderForm.refundAmount')
                            div.width_label ¥{{orderForm.refundAmount}}元
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='createTime' header-align='center',align='center',label='操作日期')
            el-table-column(prop='payType' header-align='center',align='center',label='操作类型')
                template(slot-scope="scope")
                    font(v-if='scope.row.payType === 1') 支付返回
                    font(v-if='scope.row.payType === 2') 退款返回
                    font(v-if='scope.row.payType === 3') 支付回调
                    font(v-if='scope.row.payType === 4') 退款回调
            el-table-column(prop='status' header-align='center',align='center',label='操作状态')
                template(slot-scope="scope")
                    font(v-if='scope.row.status === 0')
                      span.danger()
                      span() &nbsp; 失败
                    font(v-if='scope.row.status === 1')
                      span.success()
                      span() &nbsp; 成功
            el-table-column(header-align='center',align='center',label='操作渠道')
                template(slot-scope="scope")
                    span() &nbsp; 微信支付
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')

        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
    // import table from './table.js'
    export default {
        data () {
            return {
              title: '订单详情',
              id: '',
              dataListLoading: false,
              tableData: [],
              pageIndex: 1,
              pageSize: 10,
              totalPage: 0,
              orderForm: {
                  orgId: null, //主办方
                  orgName: '',
                  orderNumber: '', //订单编号
                  busId: '',
                  busName: '',
                  account: '',
                  orderUserName: '',
                  payTime: '',
                  payAmount: '',
                  payStatus: null,
                  refundScale: null,
                  refundAmount: ''
              },
              loading: null,
              visible: false
            }
        },
        mounted () {
            this.getDataList()
        },
        methods: {
            init (id) {
                this.id = id
                this.visible = true
                //查询订单信息
                this.$http({
                    url: this.$http.adornUrl(`/payOrder/getIdForClub/` + id),
                    method: 'get'
                }).then(data => {
                    if (data && data.code === 0) {
                    this.orderForm = data.bean
                    }
                })
            },
            // 获取数据列表
            getDataList () {
                console.log('初始化详情列表：', this.dataListLoading)
                if (!this.id) {
                    this.tableData = []
                    this.totalPage = 0
                    return
                }
                this.dataListLoading = true
                this.$http({
                    url: this.$http.adornUrl('/payLog/list'),
                    method: 'POST',
                    params: this.$http.adornParams({
                        page: this.pageIndex,
                        rows: this.pageSize,
                        orderId: this.id
                    })
                }).then(data => {
                    console.log('详情列表返回结果：', data)
                    if (data && data.code === 0) {
                        this.tableData = data.page.rows
                        this.totalPage = data.page.total
                    } else {
                        this.tableData = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getDataList()
            }
        }
    }
</script>
<style>

</style>
